import { render } from "./token-dialog.component.vue?vue&type=template&id=6fd0d52c"
import script from "./token-dialog.component.vue?vue&type=script&lang=js"
export * from "./token-dialog.component.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__